import React from 'react'
import styles from './styles.module.css'

function CKDCode() {
  return (
    <div className={styles.ckd_code}>
      <p>
        CKD病因（共计
        <span className={styles.ckd_code_span}>
          185种诊断名称，227种ICD编码
        </span>
        ）
      </p>
      <p>1、CKD分期编码 </p>
      <p>2、原发性肾小球疾病</p>
      <p>3. 继发性肾脏病</p>
      <p style={{ marginLeft: '12px' }}>1）糖尿病肾病</p>
      <p style={{ marginLeft: '12px' }}>2）高血压肾病</p>
      <p style={{ marginLeft: '12px' }}>3）梗阻性肾病</p>
      <p style={{ marginLeft: '12px' }}>4）其他继发性肾脏疾病</p>
      <p>4、肾小管间质病</p>
      <p>5、终末期肾脏病相关诊断 </p>
      <p>6、肾血管疾病 </p>
      <p>7、遗传/先天性肾脏疾病</p>
      <p>8、其他相关诊断</p>
      <p>9、需要间隔3个月及以上的肾脏相关化验检查阳性结果支持的诊断</p>
    </div>
  )
}

export default CKDCode
